import { HtmlButton } from "../../html";
import { cssModule, isNumber, mergeClasses, mergeProps, normalizeSize, useAutoFocus, useMergedRefs } from "../../shared";
const VariantProps = {
  danger: {
    color: "danger",
    shape: "pill",
    variant: "solid"
  },
  primary: {
    color: "primary",
    shape: "pill",
    variant: "solid"
  },
  secondary: {
    shape: "pill",
    variant: "outline"
  },
  tertiary: {
    shape: "pill",
    variant: "ghost"
  }
};
export function useButton({
  active,
  as,
  autoFocus,
  cssModule: module,
  fluid,
  focus,
  forwardedRef,
  hover,
  inherit,
  loading,
  shape: userShape,
  size,
  type = "button",
  variant: userVariant
}) {
  var _VariantProps$userVar;

  const buttonRef = useMergedRefs(forwardedRef);
  useAutoFocus(buttonRef, {
    delay: isNumber(autoFocus) ? autoFocus : undefined,
    isDisabled: !autoFocus
  });
  const {
    color,
    shape,
    variant
  } = mergeProps({
    shape: userShape
  }, (_VariantProps$userVar = VariantProps[userVariant]) !== null && _VariantProps$userVar !== void 0 ? _VariantProps$userVar : {});
  return {
    "aria-busy": loading,
    "aria-live": "polite",
    className: mergeClasses(module, cssModule("o-ui-button", variant, color, shape, inherit && "inherit-style", fluid && "fluid", loading && "loading", active && "active", focus && "focus", hover && "hover", normalizeSize(size))),
    ref: buttonRef,
    type: type !== null && type !== void 0 ? type : as === HtmlButton ? "button" : undefined
  };
}